<template>
  <CrudList
    title="Usuarios"
    storeName="Users"
    labelAddNew="Agregar Nuevo Usuario"
    slot-scope="{ item }"
    sortable
    canSearch
    delete-multiple
  >
    <template v-slot:hasApprovedOrder="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          {{ item.hasApprovedOrder ? 'Sí' : 'No' }}
        </v-col>
      </v-row>
    </template>
    <template v-slot:country_id="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <div v-if="item.country_id">
            {{ item.country_id === '65b7b6fe7ac3fe0c341c927c' ? 'Sí' : 'No' }}
          </div>
        </v-col>
      </v-row>
    </template>
    <!-- <template v-slot:profile_picture="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-list-item-avatar v-if="item.profile_picture">
            <img :src="item.profile_picture" alt="" style="object-fit: cover" />
          </v-list-item-avatar>
        </v-col>
      </v-row>
    </template> -->
    <template v-slot:professionals="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-btn
            color="primary"
            class="mr-4"
            v-on:click="
              $router.push('/admin/users/' + item._id + '/professionals')
            "
          >
            Profesionales
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </CrudList>
</template>

<script>
import CrudList from '@/components/Crud/CrudList';

export default {
  components: { CrudList },
};
</script>
